import { jsx } from 'react/jsx-runtime';
import Tooltip from '../Tooltip.js';

const MenuItemInfoIconTooltip = ({ label }) => {
  return /* @__PURE__ */ jsx(Tooltip, {
    label,
    delay: 0,
    children: /* @__PURE__ */ jsx(Tooltip.Info, {
      style: {
        marginLeft: "auto",
        right: "0 !important"
      }
    })
  });
};

export { MenuItemInfoIconTooltip };
//# sourceMappingURL=MenuItemInfoIconTooltip.js.map
